import { Ionicons } from '@expo/vector-icons';
import { usePathname, useRouter } from 'expo-router';
import React from 'react';
import { Platform, Pressable, Text, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useIsOnline } from '@/lib/offline/network';

/**
 * Thin strip shown at the top of the app while the device has no internet.
 * Points at the Downloads screen, the one place that works offline.
 */
export function OfflineBanner() {
  const online = useIsOnline();
  const pathname = usePathname();
  const router = useRouter();
  const insets = useSafeAreaInsets();

  if (Platform.OS === 'web' || online) return null;
  const onDownloads = pathname.startsWith('/downloads');

  return (
    <View
      style={{
        paddingTop: insets.top,
        backgroundColor: '#2B2B2B',
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingHorizontal: 16,
          paddingVertical: 8,
          gap: 12,
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, flexShrink: 1 }}>
          <Ionicons name="cloud-offline-outline" size={18} color="#FFFFFF" />
          <Text style={{ color: '#FFFFFF', fontSize: 13, fontWeight: '600' }} numberOfLines={1}>
            You&apos;re offline
          </Text>
        </View>
        {!onDownloads ? (
          <Pressable
            onPress={() => router.push('/downloads' as never)}
            accessibilityRole="button"
            hitSlop={8}
            style={({ pressed }) => ({
              paddingHorizontal: 12,
              paddingVertical: 5,
              borderRadius: 16,
              backgroundColor: pressed ? '#E0DED8' : '#FFFFFF',
            })}
          >
            <Text style={{ color: '#0D0D0D', fontSize: 12, fontWeight: '700' }}>My downloads</Text>
          </Pressable>
        ) : null}
      </View>
    </View>
  );
}
